import * as React from "react";
import "./Separator.scss";

export interface IPbrSeparator {
    style?: React.CSSProperties;
    className?: string;
}

export class PbrSeparator extends React.Component<IPbrSeparator> {

    public render() {
        return (
            <hr className={`separator ${this.props.className ? this.props.className : ""}`}
                style={{ borderTop: "rgba(33, 25, 71, .1) solid 1px", ...this.props.style }} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Separator/Separator.tsx